export default __webpack_public_path__ + "static/media/logo_footer.b938acbd.png";